import styled from 'styled-components';
import BackMembers from '../../imagens/backMembers.png';
import { FaStream } from 'react-icons/fa';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useState } from 'react';

const Container = styled.div`
    min-height: 100vh;
    color: #fff;
    background: url(${BackMembers});
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: right;
    background-position-y: bottom;
`;
const FutInfo = styled.div`
    text-align: center;
    padding: 24px 16px;
`;
const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
`;
const SubInfo = styled.p`
    margin-top: 4px;
    font-size: 16px;
`;
const MembersSection = styled.section`
    margin-top: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Ul = styled.ul`
    padding: 0;
    margin: 0;
    width: 500px;
    max-width: 80vw;
    max-height: 60vh;
    overflow: auto;
    padding-right: 10px;
`
const Li = styled.li`
    display: flex;
    justify-content: space-between;
    padding: 15px 30px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border: 1px solid rgba(206, 206, 206, 0.52);
    border-radius: 12px;
    color: white;
    font-size: 16px;
    margin-bottom: 15px;
`
const Name = styled.div`

`
const Options = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
        margin-left: 20px;
    }
`

const infos = ['Anderson Lavorato' , 'Marcão' , 'Juan' , 'Douglas' , 'Miguel' , 'Jonny' , 'Peterson' , 'Waltin' , 'Gabriel' , 'Rafa', 'Rodrigo', 'Luizinho', 'japa', 'Gustavo', 'Henrique', 'Amauri', 'Léo', 'Dudu', 'Jean', 'Felipe Cruz'];

function MemberSection() {
    const [items, setItems] = useState(infos);
    
    const handleDragEnd = (result) => {
        if (!result.destination) 
            return;

        const reorderedItems = Array.from(items);
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        setItems(reorderedItems);
    };

    return(
        <Container>
            <FutInfo>
                <Title>Mensalistas</Title>
                <SubInfo>Quantidade: { infos.length }</SubInfo>
            </FutInfo>
            <MembersSection>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="list">
                    {(provided) => (
                        <Ul ref={provided.innerRef} {...provided.droppableProps}>
                            {items.map((item, index) => (
                                <Draggable key={index} draggableId={String(index)} index={index}>
                                    {(provided) => (
                                        <Li 
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <Name>{item}</Name>
                                            <Options>
                                                Editar
                                                <FaStream />
                                            </Options>
                                        </Li>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </Ul>
                    )}
                </Droppable>
            </DragDropContext>
            </MembersSection>
        </Container>
    )
}

export default MemberSection;